// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Switcher.module.scss  */
.Switcher-module-Root_1rR {
  display: inline-flex;
  justify-content: space-between;
  align-items: center; }
  .Switcher-module-Root_1rR.Switcher-module-disabled_1L1 {
    pointer-events: none;
    opacity: 0.4; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Switcher/Switcher.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB,EAAE;EACrB;IACE,oBAAoB;IACpB,YAAY,EAAE","sourcesContent":["/*  imported from Switcher.module.scss  */\n.Switcher-module-Root_1rR {\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center; }\n  .Switcher-module-Root_1rR.Switcher-module-disabled_1L1 {\n    pointer-events: none;\n    opacity: 0.4; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
